import { EffectCarousel, PopIn, imageLoaded, matchesMediaQuery } from 'theme';
import { Delegate, animate, inView, stagger } from 'vendor';

if (!window.customElements.get('up-privacy-banner')) {
  var upPrivacyBanner = class extends PopIn {
    constructor() {
      super();
      this.delegate = new Delegate(this);
      this.preferenceModal = this.querySelector('x-modal');

      window.Shopify.loadFeatures([
        {
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: this.onConsentLibraryLoaded.bind(this),
        },
      ]);

      this.preferenceModal
        .querySelector('[data-action="accept"]')
        .addEventListener('click', this.applyConsent.bind(this, true, true, true));
      this.preferenceModal
        .querySelector('[data-action="pref-validate"]')
        .addEventListener('click', this.validateCookiesPreferences.bind(this));
    }
    connectedCallback() {
      super.connectedCallback();
      this.delegate.on('click', '[data-action="accept"]', this.applyConsent.bind(this, true, true, true));
      this.delegate.on('click', '[data-action="decline"]', this.applyConsent.bind(this, false, false, false));
    }

    disconnectedCallback() {
      this.delegate.off();
    }

    onConsentLibraryLoaded() {
      if (
        window.Shopify.customerPrivacy?.shouldShowBanner() &&
        Object.values(window.Shopify.customerPrivacy.currentVisitorConsent()).every((x) => x === '')
      ) {
        this.show();
      } else {
        gtag('consent', 'update', {
          ad_user_data: window.Shopify.customerPrivacy?.firstPartyMarketingAllowed() ? 'granted' : 'denied',
          ad_personalization: window.Shopify.customerPrivacy?.firstPartyMarketingAllowed() ? 'granted' : 'denied',
          ad_storage: window.Shopify.customerPrivacy?.firstPartyMarketingAllowed() ? 'granted' : 'denied',
          analytics_storage: window.Shopify.customerPrivacy?.analyticsProcessingAllowed() ? 'granted' : 'denied',
        });
      }
    }

    validateCookiesPreferences() {
      const inputs = this.preferenceModal.querySelectorAll('.checkbox-control input:not(:disabled)');
      const choices = Array.from(inputs).map((item) => item.checked);
      this.applyConsent(...choices);
    }

    applyConsent(preferences, analytics, marketing) {
      gtag('consent', 'update', {
        ad_user_data: marketing ? 'granted' : 'denied',
        ad_personalization: marketing ? 'granted' : 'denied',
        ad_storage: marketing ? 'granted' : 'denied',
        analytics_storage: analytics ? 'granted' : 'denied',
      });

      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: analytics,
          marketing: marketing,
          preferences: preferences,
          sale_of_data: false,
        },
        () => {}
      );

      this.preferenceModal.hide();
      this.hide();
    }
  };
  window.customElements.define('up-privacy-banner', upPrivacyBanner);
}

if (!window.customElements.get('up-featured-products-slideshow')) {
  class upFeaturedProductSlideshow extends EffectCarousel {
    constructor() {
      super();
      this.addEventListener('carousel:change', this.updateButtonLink.bind(this));

      if (this.hasAttribute('autoplay') && this.player) {
        this.player.addEventListener('player:start', this.handleAutoplayProgress.bind(this));
        this.player.addEventListener('player:stop', this.handleAutoplayProgress.bind(this));
        this.player.addEventListener('player:visibility-pause', this.handleAutoplayProgress.bind(this));
        this.player.addEventListener('player:visibility-resume', this.handleAutoplayProgress.bind(this));
      }
    }
    updateButtonLink(event) {
      const productCard = event.detail.cell.querySelector('.product-card');
      if (productCard.hasAttribute('handle')) {
        this.nextElementSibling.href = `${Shopify.routes.root}products/${productCard.getAttribute('handle')}`;
      }
    }

    async handleAutoplayProgress(event) {
      switch (event.type) {
        case 'player:start': {
          let autoplayDuration = this.getAttribute('autoplay');
          this.parentElement.style.setProperty('--slideshow-progress-duration', `${autoplayDuration}s`);
          this.parentElement.style.setProperty('--slideshow-progress-play-state', 'running');
          break;
        }
        case 'player:stop': {
          this.parentElement.style.setProperty('--slideshow-progress-duration', `0s`);
          this.parentElement.style.setProperty('--slideshow-progress-play-state', 'paused');
          break;
        }
        case 'player:visibility-pause': {
          this.parentElement.style.setProperty('--slideshow-progress-play-state', 'paused');
          break;
        }
        case 'player:visibility-resume': {
          this.parentElement.style.setProperty('--slideshow-progress-play-state', 'running');
          break;
        }
      }
    }

    // Transition on reveal
    async createOnBecameVisibleAnimationControls(toSlide) {
      await imageLoaded(toSlide.querySelectorAll('img'));
      if (toSlide.hasAttribute('reveal-on-scroll')) {
        return animate(
          toSlide,
          { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
          { duration: 0.8 }
        );
      }
      return { finished: Promise.resolve() };
    }
  }
  window.customElements.define('up-featured-products-slideshow', upFeaturedProductSlideshow);
}

// Animation
if (!window.customElements.get('up-typewriter')) {
  class upTypewriter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (matchesMediaQuery('motion-safe')) {
        inView(this, () =>
          animate(
            this.querySelectorAll('h1, p'),
            {
              // opacity: [0, 1],
              width: ['0%', '100%'],
            },
            {
              duration: 0.5,
              easing: 'linear',
              delay: stagger(0.25, { start: 0, easing: 'linear' }),
            }
          )
        );
      }
    }

    disconnectedCallback() {}
  }
  window.customElements.define('up-typewriter', upTypewriter);
}

// Glitch effect
Array.from(document.querySelectorAll('.up-glitch')).forEach((element) => {
  inView(element, () => {
    element.classList.add('up-glitch-animation');
  }),
    { margin: '-50px 0px' };
});

if (!window.customElements.get('up-perso')) {
  class upPerso extends HTMLElement {
    constructor() {
      super();
      this.inputs = this.querySelectorAll('input');

      this.inputs.forEach((input) => {
        input.addEventListener('change', this.verifyInputs.bind(this));
      });


      this.messagesRemainingChar = this.querySelectorAll('.form-control__max-characters-count');

      this.inputs.forEach((input, index) => {
        input.addEventListener(
          'keyup',
          this.showRemainingChar.bind(this, input, this.messagesRemainingChar[index]),
          false
        );
      });
    }

    get disabled() {
      return this.hasAttribute('disabled');
    }

    set disabled(val) {
      val ? this.setAttribute('disabled', '') : this.removeAttribute('disabled');
    }

    connectedCallback() {
      document.addEventListener('variant:change', this.onVariantChange.bind(this));
    }

    disconnectedCallback() {}

    onVariantChange(event) {
      const showPerso =
        event.detail.variant?.available && event.detail.variant?.options.includes('Avec personnalisation');
      this.disabled = !showPerso;
      showPerso ? this.classList.remove('hidden') : this.classList.add('hidden');
      this.inputs.forEach((input) => {
        input.disabled = !showPerso;
      });
    }

    showRemainingChar(input, messageRemainingChar) {
      const remainingChar = input.maxLength - input.value.length;
      messageRemainingChar.textContent = `${remainingChar} caractères restants`;
    }

    verifyInputs() {
      if (!this.disabled) {
        if (Array.from(this.inputs).every((input) => input.checkValidity() === false)) {
          this.inputs[0].reportValidity();
        }
        // Check for emojis
        const emojisRegex =
          /\p{RI}\p{RI}|\p{Emoji}(\p{EMod}|\uFE0F\u20E3?|[\u{E0020}-\u{E007E}]+\u{E007F})?(\u200D(\p{RI}\p{RI}|\p{Emoji}(\p{EMod}|\uFE0F\u20E3?|[\u{E0020}-\u{E007E}]+\u{E007F})?))*/gu;

        for (const input of this.inputs) {
          const detectedEmojis = input.value.match(emojisRegex)?.filter((emoji) => !/^[#*0-9©®]$/.test(emoji)) || [];
          if (detectedEmojis.length > 0) {
            detectedEmojis.forEach((emoji) => {
              input.value = input.value.replace(emoji, '');
            });
            input.setCustomValidity('Les Emojis ne sont pas autorisés.');
            input.reportValidity();
          } else {
            input.setCustomValidity('');
          }
        }
      }
    }
  }
  window.customElements.define('up-perso', upPerso);
}
